<div class="puzzle-changer-form">

  <ion-list>
    <ion-item *ngIf="languageParameterEnabled &&languages && languages.length && displayLanguagePicker" lines="bottom">
      <ion-select [placeholder]="'PUZZLE.puzzle_changer_form.language.label'|translate" interface="popover"
                  [interfaceOptions]="popoverOptions"
                  (ionChange)="languageChanged()" [(ngModel)]="languageIndex"
                  label="{{'PUZZLE.puzzle_changer_form.language.label'|translate}}">
        <ion-select-option *ngFor="let lang of languages; index as i" [value]="i">{{ lang.label }}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item lines="bottom"
              *ngIf="difficultyParameterEnabled && difficulties && difficulties.length && difficultyChangerInForm">
      <ion-select [placeholder]="'PUZZLE.puzzle_changer_form.difficulty.label'|translate" interface="popover"
                  [interfaceOptions]="popoverOptions"
                  [(ngModel)]="selectedDifficulty" (ionChange)="difficultyChanged()"
                  label="{{'PUZZLE.puzzle_changer_form.difficulty.label'|translate}}">
        <ion-select-option *ngFor="let diff of difficulties" [value]="diff">{{ diff }}</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>
  <!--  <div class="puzzle-modal-buttons">-->
  <!--    <ion-button color="primary"-->
  <!--                *ngIf="dirty && !hideApplyButton && languageParameterEnabled && difficultyParameterEnabled && languages && languages.length && difficulties && difficulties.length"-->
  <!--                (click)="apply()" fill="solid" [ngClass]="{dirty: dirty}">-->
  <!--      <span>{{'PUZZLE.puzzle_changer_form.button.label'|translate}}</span>-->
  <!--      <ion-icon slot="end" name="refresh-sharp"></ion-icon>-->
  <!--    </ion-button>-->
  <!--  </div>-->

</div>
